import { BORDER_COLORS as BC, SURFACE_COLORS as SC, TEXT_COLORS as TC } from '@constants/colors.ts';
import { DESKTOP_SIZES, FONT_FAMILY, SIZES } from '@constants/fonts.ts';
import styled from 'styled-components';

export const OuterWrapper = styled.div`
    width: 100%;
    overflow-x: auto;
`;

export const TableWrapper = styled.table`
    width: 100%;
    border-collapse: collapse;
    min-width: 900px;
`;

export const HeaderRow = styled.tr`
    background: ${SC.tableCellDark};
`;

export const HeaderItem = styled.th<{ width?: string; $isActive?: boolean }>`
    user-select: none;
    cursor: pointer;
    ${FONT_FAMILY.poppins};
    color: ${({ $isActive }) => ($isActive ? TC.action : TC.heading)};
    ${DESKTOP_SIZES[SIZES.BODY_SM].lineHeight};
    ${DESKTOP_SIZES[SIZES.BODY_SM].fontSize};
    ${({ $isActive }) =>
        $isActive ? DESKTOP_SIZES[SIZES.BODY_XL_BOLD].fontWeight : DESKTOP_SIZES[SIZES.BODY_SM_MED].fontWeight};
    width: ${({ width }) => width ?? 'auto'};
    padding: 8px 24px 8px 0;

    &:first-child {
        padding-left: 16px;
    }

    &:last-child {
        padding-right: 16px;
    }
`;

export const HeaderItemContent = styled.div<{ $shouldAlignToRight: boolean }>`
    display: flex;
    align-items: center;
    justify-content: ${({ $shouldAlignToRight }) => ($shouldAlignToRight ? 'flex-end' : 'flex-start')};

    svg {
        width: 16px;
        height: 16px;
    }
`;

export const Row = styled.tr`
    border-bottom: 1px solid ${BC.primary};
    &:nth-child(even) {
        background: ${SC.tableCellDark};
    }
    &:nth-child(odd) {
        background: ${SC.white};
    }
`;

export const CellItem = styled.td<{ $shouldAlignToRight: boolean; width?: string }>`
    text-align: ${({ $shouldAlignToRight }) => ($shouldAlignToRight ? 'right' : 'left')};
    ${FONT_FAMILY.poppins};
    width: ${({ width }) => width ?? 'auto'};
    padding: 8px 24px 8px 0;

    &:first-child {
        padding-left: 16px;
    }
    &:last-child {
        padding-right: 16px;
        text-align: center;
    }
`;

export const EmptyRow = styled.tr`
    td {
        padding: 32px 16px;
    }
`;

export const CenteredWrapper = styled.div`
    display: flex;
    justify-content: center;
`;

export const CertificateWrapper = styled.div`
    cursor: pointer;
`;
